import { observer } from 'mobx-react';
import React from 'react';

import Button from '@mui/material/Button';

import useStores from 'hooks/use-stores';

import Hubspot from './Hubspot';

/**
 * Button implements interaction with hubspot form
 */
const HubspotButton = ({ hubspot, onClick, ...rest }) => {
    const { userStore } = useStores();

    const handleClick = (e) => {
        e.preventDefault();
        hubspot && Hubspot.send(hubspot, { email: userStore.user.email });
        onClick(e);
    };

    return <Button {...rest} onClick={handleClick} />;
};

export default observer(HubspotButton);
